import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { CopyToClipboardDirective } from "../directives/copy-to-clipboard.directive";
import { TooltipDirective } from "../directives/tooltip.directive";
import { NoArrowDirective } from "./no-down-arrow.directive";
import { UiImageLoaderDirective } from "./img-src.directive";

@NgModule({
  imports: [CommonModule, IonicModule, CopyToClipboardDirective, TooltipDirective, NoArrowDirective, UiImageLoaderDirective],
  exports: [CopyToClipboardDirective, TooltipDirective, NoArrowDirective, UiImageLoaderDirective],
})
export class DirectiveModule {}
